var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlug1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303.01 137.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "cls-1",
    d: "M63.87,40.94A32,32,0,0,0,0,42.92L.12,99.47H16.87V75H29.76A34.09,34.09,0,0,0,63.87,40.94ZM30.38,58.3H16.87V42.92a15.15,15.15,0,0,1,30.25-1.36A16.75,16.75,0,0,1,30.38,58.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    className: "cls-1",
    d: "M157.2,67.6a15.26,15.26,0,0,1-30.51,0V10.93H110.07V67.6a31.88,31.88,0,0,0,63.75,0V10.93H157.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    className: "cls-1",
    d: "M269.54,46.89h-43.9V63.51h26.41a27.3,27.3,0,1,1-26-35.59,27,27,0,0,1,19.1,7.81l12-12a44.29,44.29,0,1,0,13.14,31.5A45.63,45.63,0,0,0,269.54,46.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-1",
    d: "M70.11,0V78.53A31.87,31.87,0,0,0,102,110.4V93.66A15.11,15.11,0,0,1,86.86,78.53V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "cls-1",
    d: "M303,110.4V31.87A31.86,31.86,0,0,0,271.14,0V16.74a15.11,15.11,0,0,1,15.13,15.13V110.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-1",
    d: "M22.86,136.47a4.07,4.07,0,0,1-3-1.29,4.49,4.49,0,0,1,0-6.2,4.24,4.24,0,0,1,6.07,0,4.55,4.55,0,0,1,0,6.2A4.11,4.11,0,0,1,22.86,136.47Zm0-10a5.6,5.6,0,0,0-5.68,5.61,5.35,5.35,0,0,0,1.65,4,5.76,5.76,0,0,0,8.07,0,5.33,5.33,0,0,0,1.63-4,5.58,5.58,0,0,0-5.67-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "cls-1",
    d: "M36.67,137.53h3.19v-4.18h4.55v-2.67H39.86v-1.33h5.21v-2.7h-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "cls-1",
    d: "M53.61,134.84a1.61,1.61,0,0,1-1.19-.45A1.74,1.74,0,0,1,52,133v-6.38h-3.2v6.56a4.2,4.2,0,0,0,1.36,3.34,5.1,5.1,0,0,0,3.5,1.18,5.16,5.16,0,0,0,3.51-1.18,4.22,4.22,0,0,0,1.34-3.34v-6.56H55.27V133a1.81,1.81,0,0,1-.45,1.36A1.71,1.71,0,0,1,53.61,134.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-1",
    d: "M65.81,137.53H69v-8.18h3.41v-2.7h-10v2.7h3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-1",
    d: "M81.2,134.84a1.63,1.63,0,0,1-1.19-.45,1.74,1.74,0,0,1-.47-1.36v-6.38H76.35v6.56a4.16,4.16,0,0,0,1.36,3.34,5.07,5.07,0,0,0,3.49,1.18,5.14,5.14,0,0,0,3.51-1.18,4.22,4.22,0,0,0,1.35-3.34v-6.56h-3.2V133a1.81,1.81,0,0,1-.45,1.36,1.69,1.69,0,0,1-1.21.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "cls-1",
    d: "M90.58,137.53h3.19v-2.29h2.1l1.25,2.3h3.64l-2-3.24a3.77,3.77,0,0,0,1.27-1.48,4.18,4.18,0,0,0,.44-1.87,4.09,4.09,0,0,0-1.31-3.09,5.39,5.39,0,0,0-3.74-1.2H90.58Zm3.19-5v-3.19h1.67a1.63,1.63,0,0,1,1.17.45,1.59,1.59,0,0,1,.45,1.14,1.52,1.52,0,0,1-.45,1.13,1.58,1.58,0,0,1-1.19.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-1",
    d: "M107.65,132.09a2.76,2.76,0,0,1,.74-2,2.34,2.34,0,0,1,1.77-.77,2.37,2.37,0,0,1,1.81.75,3.1,3.1,0,0,1,0,3.95,2.5,2.5,0,0,1-3.61,0,2.84,2.84,0,0,1-.71-2Zm-3.32,0a5.41,5.41,0,0,0,1.63,4,6.24,6.24,0,0,0,8.41,0,5.74,5.74,0,0,0,0-8,6.3,6.3,0,0,0-8.41,0A5.43,5.43,0,0,0,104.33,132.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "cls-1",
    d: "M123.8,137.53h1.38l1-2.12h6.65l1,2.12h1.39l-5.14-10.88h-1.16Zm2.89-3.23,1.85-3.81c.32-.67.65-1.44,1-2.3l1,2.28,1.83,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "cls-1",
    d: "M138.46,132.09a5.38,5.38,0,0,0,1.64,4,5.75,5.75,0,0,0,8.06,0l-.85-.92a4.25,4.25,0,0,1-3.18,1.34,4.05,4.05,0,0,1-3-1.29,4.49,4.49,0,0,1,0-6.2,4.1,4.1,0,0,1,3.09-1.28,4.16,4.16,0,0,1,2.87,1.11l.82-.92a5.46,5.46,0,0,0-3.77-1.41,5.58,5.58,0,0,0-5.66,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-1",
    d: "M157.64,136.47a4.05,4.05,0,0,1-3-1.29,4.49,4.49,0,0,1,0-6.2,4.23,4.23,0,0,1,6.06,0,4.52,4.52,0,0,1,0,6.2A4.08,4.08,0,0,1,157.64,136.47Zm0-10a5.58,5.58,0,0,0-5.67,5.61,5.38,5.38,0,0,0,1.64,4,5.77,5.77,0,0,0,8.08,0,5.63,5.63,0,0,0,0-7.94,5.43,5.43,0,0,0-4-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    className: "cls-1",
    d: "M168.35,137.53h1.34v-8.75l.21.32c.13.22.33.5.58.87s.51.71.76,1l5,6.53h1.34V126.65h-1.34v8.81l-.2-.32c-.12-.2-.31-.47-.54-.82s-.45-.65-.67-.92l-5.21-6.75h-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    className: "cls-1",
    d: "M186.25,137.53h1.34v-9.69h4v-1.19h-9.4v1.19h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    className: "cls-1",
    d: "M196.21,137.53h8.49v-1.19h-7.14v-4H204v-1.18h-6.45v-3.29h6.9v-1.19h-8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    className: "cls-1",
    d: "M208.68,132.09a5.39,5.39,0,0,0,1.65,4,5.75,5.75,0,0,0,8.06,0l-.85-.92a4.25,4.25,0,0,1-3.18,1.34,4.05,4.05,0,0,1-3-1.29,4.49,4.49,0,0,1,0-6.2,4.1,4.1,0,0,1,3.09-1.28,4.16,4.16,0,0,1,2.87,1.11l.82-.92a5.47,5.47,0,0,0-3.78-1.41,5.6,5.6,0,0,0-5.66,5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    className: "cls-1",
    d: "M223,137.53h8.48v-1.19H224.3v-4h6.44v-1.18H224.3v-3.29h6.9v-1.19H223Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    className: "cls-1",
    d: "M239.25,137.53h1.38l1-2.12h6.65l1,2.12h1.39l-5.14-10.88h-1.16Zm2.89-3.23,1.85-3.81c.32-.67.65-1.44,1-2.3l1,2.28,1.83,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    className: "cls-1",
    d: "M259.58,126.48a5.58,5.58,0,0,0-5.67,5.61,5.38,5.38,0,0,0,1.64,4,5.5,5.5,0,0,0,4,1.65,5.65,5.65,0,0,0,3.51-1.16l1.06,1.06.87-.88-1-1a5.51,5.51,0,0,0,1.29-3.59,5.6,5.6,0,0,0-5.68-5.61Zm0,10a4.05,4.05,0,0,1-3-1.29,4.49,4.49,0,0,1,0-6.2,4.23,4.23,0,0,1,6.06,0,4.28,4.28,0,0,1,1.23,3.11,4.54,4.54,0,0,1-.84,2.63l-1.46-1.46-.86.86,1.46,1.48A4,4,0,0,1,259.58,136.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    className: "cls-1",
    d: "M274.61,137.7a4.49,4.49,0,0,0,3.19-1.23,4.09,4.09,0,0,0,1.31-3.14v-6.68h-1.35v6.68a3,3,0,0,1-.9,2.25,3.15,3.15,0,0,1-2.25.89,3.09,3.09,0,0,1-2.24-.89,3,3,0,0,1-.92-2.25v-6.68h-1.34v6.68a4.08,4.08,0,0,0,1.3,3.14,4.48,4.48,0,0,0,3.2,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    className: "cls-1",
    d: "M284.47,137.53h1.35V126.65h-1.35Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlug1Dark);
export default __webpack_public_path__ + "static/media/logo-plug1-dark.42086be63fddd51545f5875c6476c7f5.svg";
export { ForwardRef as ReactComponent };